import { Language, TranslationEntity } from '@seaters-app/constants';

export const hasDefaultText = (data: TranslationEntity[]): boolean => {
  return !!data.find((translation) => {
    return translation.lang === Language.EN && translation.text.trim() !== '';
  });
};
